export { default as PhoneSolidIcon } from './PhoneSolidIcon';
